(function () {
  'use strict';

  var scrollObserver = null;

  function initInfiniteScroll() {
    if (scrollObserver) {
      scrollObserver.disconnect();
      scrollObserver = null;
    }

    var sentinel = document.getElementById('twc-load-more-sentinel');
    if (!sentinel) return;

    var loading = false;
    var nextUrl = sentinel.dataset.nextUrl;

    function loadMore() {
      if (loading || !nextUrl) return;
      loading = true;
      sentinel.setAttribute('aria-busy', 'true');

      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newItems = doc.querySelectorAll('#product-grid .grid__item');
          var grid = document.getElementById('product-grid');

          newItems.forEach(function (item) {
            grid.appendChild(item);
          });

          var nextSentinel = doc.getElementById('twc-load-more-sentinel');
          nextUrl = nextSentinel ? nextSentinel.dataset.nextUrl : null;

          loading = false;
          sentinel.setAttribute('aria-busy', 'false');

          if (!nextUrl) {
            scrollObserver.disconnect();
            scrollObserver = null;
            sentinel.remove();
          } else {
            // Unobserve + re-observe forces a fresh intersection check.
            // Without this, if the sentinel is still in the viewport after
            // products are appended, the observer never re-fires.
            scrollObserver.unobserve(sentinel);
            scrollObserver.observe(sentinel);
          }
        })
        .catch(function () {
          loading = false;
          sentinel.setAttribute('aria-busy', 'false');
        });
    }

    scrollObserver = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) loadMore();
    }, { rootMargin: '400px' });

    scrollObserver.observe(sentinel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfiniteScroll);
  } else {
    initInfiniteScroll();
  }

  // Re-init after Shopify AJAX replaces the product grid (filter / sort changes).
  // Script tags injected via innerHTML don't re-execute, so we watch the container.
  document.addEventListener('DOMContentLoaded', function () {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;

    new MutationObserver(function () {
      setTimeout(initInfiniteScroll, 50);
    }).observe(container, { childList: true });
  });
})();
